var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:_vm.classes,attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":(e) => _vm.$emit('click', e)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }